import { Component, Input, OnInit } from '@angular/core';
import { UtilsService } from '../utils.service';
import { IKeyValue } from '../../../models/ikey-value';
import { GetEntityQuery, ListAlertsQuery } from '../../API.service';
import { CriticalAlertTypeEnum } from '../enums/critical-alert-type.enum';
import { NGXLogger } from 'ngx-logger';
import { RootEntityContextService } from '../root-entity-context.service';

interface AlertModal extends ListAlertsQuery {
  open: boolean;
  hidden: boolean;
}

@Component({
  selector: 'cygov-critical-alerts',
  templateUrl: './critical-alerts.component.html',
  styleUrls: ['./critical-alerts.component.scss'],
  standalone: false,
})
export class CriticalAlertsComponent implements OnInit {
  @Input() entityId: string;
  entity: GetEntityQuery;
  alertMap: IKeyValue<AlertModal[]>;
  criticalAlertTypeEnum = CriticalAlertTypeEnum;
  loading = true;
  isBnB = UtilsService.isBnB;
  isBnBCyberSite = UtilsService.isBnBCyberSite;
  isMidMarket = UtilsService.isMidMarket;
  constructor(
    private logger: NGXLogger,
    private rootEntityContextService: RootEntityContextService
  ) {}

  async ngOnInit() {
    try {
      this.entity = await this.rootEntityContextService.getRootEntityById(this.entityId);
      const alertMap = {};
      let rawAlerts: any[] = [];

      if (this.entity.industry) {
        // passing hardcoded value for mid market as for now there are only 6 files present on s3
        const industry = UtilsService.isMidMarket ? 'RETAIL' : this.entity.industry;
        rawAlerts = await this.rootEntityContextService.getAlertsByIndustry(industry);
      }

      // sort alerts by priority
      const sortedAlerts = UtilsService.sortByProp(rawAlerts, 'priority');

      // format all alerts
      sortedAlerts.forEach((alert: { type: string; content: string; priority: number }) => {
        alertMap[alert.type] = alertMap[alert.type] || [];
        alertMap[alert.type].push({
          content: alert.content,
          open: false,
          hidden: false,
        });
      });

      // cut only 3 items of each alert type
      this.alertMap = {};
      Object.keys(alertMap).forEach(type => {
        this.alertMap[type] = alertMap[type].slice(0, 3);
      });
      this.loading = false;
    } catch (e) {
      this.logger.error('CriticalAlertsComponent - Error: ', e);
      this.alertMap = {};
      this.loading = false;
    }
  }

  isOverflowing(el: HTMLElement): boolean {
    return el ? el.scrollWidth > el.clientWidth : false;
  }

  togglePanel(event, sectionKey, alertToOpen) {
    const openAction = !alertToOpen.open;
    const currentTarget = event.currentTarget;
    this.logger.log(openAction);
    this.alertMap[sectionKey].forEach(alert => {
      if (openAction) {
        // toggle - open
        if (alert.content === alertToOpen.content) {
          currentTarget.classList.add('zero-height');
          currentTarget.classList.remove('show');
          setTimeout(() => {
            currentTarget.classList.add('open');
          }, 0);
          alert.open = true;
        } else {
          alert.open = false;
          alert.hidden = true;
        }
      } else {
        // toggle - close
        currentTarget.classList.remove('open');
        currentTarget.classList.remove('zero-height');
        currentTarget.classList.add('show');
        alert.open = false;
        alert.hidden = false;
      }
    });
  }

  closePanel(sectionKey, alert) {
    this.alertMap[sectionKey].forEach(alertItem => {
      if (alert.content === alertItem.content) {
        alert.open = false;
      } else {
        alert.hidden = false;
      }
    });
  }
}
